var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonLogout = function SvgButtonLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    viewBox: "0 0 50 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFCE41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.8 41.6 13.4-15.2-14.4-14.8-.4 10.9-8.8-.6L19 34.3l7.2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.1 38.6-.1 5.2-24-.4-.9-32.3L38.8 9l-.2 6.6 6 6.1L46 4.9 6.7 6.6 10 48.2l32.8-.9 1.3-15.5z"
  }))));
};
export default SvgButtonLogout;